import { render, staticRenderFns } from "./SupportInfos.vue?vue&type=template&id=52b61688&scoped=true"
import script from "./SupportInfos.vue?vue&type=script&lang=js"
export * from "./SupportInfos.vue?vue&type=script&lang=js"
import style0 from "./SupportInfos.vue?vue&type=style&index=0&id=52b61688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b61688",
  null
  
)

export default component.exports